import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-window-size-tool',
  imports: [CommonModule],
  templateUrl: './window-size-tool.component.html',
  styleUrl: './window-size-tool.component.css'
})
export class WindowSizeToolComponent implements OnInit {
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  isOpen = false;

ngOnInit(): void {
    this.updateSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateSize();
  }

  private updateSize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  }

  getBreakpoint(): string {
    if (this.width >= 3840) return '4K';
    if (this.width >= 2560) return '2K';
    if (this.width >= 2304) return 'Full HD+';
    if (this.width >= 1920) return 'Full HD';
    if (this.width >= 1536) return 'Desktop/Tablet';
    if (this.width >= 1280) return 'HD/small Tablet';
    if (this.width >= 1024) return 'Very small Tablet';
    if (this.width >= 768) return 'md';
    if (this.width >= 640) return 'sm';
    return 'xs';
  }

getTailwindClass(): string {
  if (this.width >= 3840) return '6xl';      // 4K
  if (this.width >= 2560) return '5xl';      // 2K/1440p
  if (this.width >= 2304) return '4xl';      // Full HD+
  if (this.width >= 1920) return '3xl';      // Full HD
  if (this.width >= 1536) return '2xl';      // Desktop XL
  if (this.width >= 1280) return 'xl';       // HD
  if (this.width >= 1024) return 'lg';       // Desktop
  if (this.width >= 768) return 'md';        // Tablet
  if (this.width >= 640) return 'sm';        // Mobile Large
  return 'base';                             // Mobile
}

}